/**
 * Checks for an auth token and associated metadata in the current URL
 */
export function getUrlToken() {
    if (typeof document === "undefined") {
        // Not in web
        return undefined;
    }
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const authResultString = params.get("authResult");
    const walletId = params.get("walletId");
    const authProvider = params.get("authProvider");
    const authCookie = params.get("authCookie");
    if ((authCookie || authResultString) && walletId) {
        const authResult = (() => {
            if (authResultString) {
                params.delete("authResult");
                return JSON.parse(decodeURIComponent(authResultString));
            }
        })();
        params.delete("walletId");
        params.delete("authProvider");
        params.delete("authCookie");
        window.history.pushState({}, "", `${window.location.pathname}?${params.toString()}`);
        return { walletId, authResult, authProvider, authCookie };
    }
    return undefined;
}
//# sourceMappingURL=get-url-token.js.map